function fgLine() {
  return {
    restrict: "C",
    link: function (scope, element) {
      const input = element.find(".form-control").first();

      input.on("focus", function () {
        element.addClass("fg-toggled");
      });

      input.on("blur", function () {
        element.removeClass("fg-toggled");
      });
    },
  };
}

export default fgLine;
